(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let imageObserver;

  const pauseAll = () => {
    document.querySelectorAll('.acha-gallery__video').forEach((video) => video.pause());
  };

  const init = () => {
    observer?.disconnect();
    imageObserver?.disconnect();
    pauseAll();

    imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.acha-gallery__image[loading="lazy"]').forEach((image) => {
            image.loading = 'eager';
          });
          imageObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '100% 0px' }
    );

    document.querySelectorAll('.acha-gallery').forEach((gallery) => imageObserver.observe(gallery));

    if (reducedMotion.matches) return;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (!(video instanceof HTMLVideoElement)) return;

          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.45 }
    );

    document.querySelectorAll('.acha-gallery__video').forEach((video) => observer.observe(video));
  };

  reducedMotion.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  init();
})();
